module.exports = __webpack_public_path__ + "static/media/banner_1.0c06d9d6.webp";